<script>
  import { fade } from 'svelte/transition'
  import BaseDonut from '../core/dataviz/BaseDonut.svelte'
  import IntersectionObserver from '../util/IntersectionObserver.svelte'

  export let value
  export let min = 0

  export let max = 100
  export let suffix = '%'
  export let isDecimal = false

  let className
  export { className as class }

  const donutSmallBreakpoint = 460
  const donutSuperSmallBreakpoint = 320
  const donutBigBreakpoint = 600
  
  let responsiveClass = 'normal'
  let contentHeightFactor = 2.5 

  let dialStartAngle = 90
  let dialEndAngle = 89.999

  let donutH
  let donutW

  const calcResponsiveStuff = (w)=> {
    if(w > donutSmallBreakpoint) {
      if(w >= donutBigBreakpoint) {
        responsiveClass = 'large'
        contentHeightFactor = 2.2
      } else {
        responsiveClass = 'normal'
        contentHeightFactor = 2.1
      }
    } else if(w > donutSuperSmallBreakpoint) {
      responsiveClass = 'small'
      contentHeightFactor = 2.2
    } else {
      responsiveClass = 'very-small'
      contentHeightFactor = 2
    }
  }

  $: calcResponsiveStuff(donutW)  
</script>

<IntersectionObserver class="overlay-donut { className }" let:intersecting once bottom={ 500 }>
  { #if intersecting }
    <div class="wrapper p-4" in:fade={{ delay:150 }}>
      <div class="donut-wrapper" bind:clientHeight={ donutH } bind:clientWidth={ donutW }>
        <BaseDonut value={ value } displayValue={ false } min={ min } max={ max } dialStartAngle={ dialStartAngle } dialEndAngle={ dialEndAngle }  suffix={ suffix } isDecimal={ isDecimal } />
      </div>
      
      <div class="abso-slot" style="{donutH && contentHeightFactor ? `height: ${ donutH / contentHeightFactor }px;` : ''}">
        <div class="slot-content { responsiveClass }" style="{donutW ? `max-width: ${ donutW * .5 }px;` : ''}">
          <slot />
        </div>
      </div>
    </div>
  { :else }
    <div style="min-height: 400px;"></div>  
  { /if }
</IntersectionObserver>

<style>
  .wrapper {
    position: relative;
  }

  .abso-slot {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 0;
    left: 0;
    /* border: 5px solid yellow; */
  }

  .slot-content {
    margin: 0 auto;
    font-size: 2rem;
  }

  .slot-content.small {
    font-size: 1rem;
  }

  .slot-content.very-small {
    font-size: .6rem;
  }

  .slot-content.large {
    font-size: 2rem;
  }
</style>